import React from 'react';

import InfoTable from '../../../../../../../components/table/InfoTable';
import './UserInfoTransferTable.scss';
import { ColumnType } from '../types';

interface IUserInfoTransferTableProps {
  columns: ColumnType[];
}

const UserInfoTransferTable = (props: IUserInfoTransferTableProps): JSX.Element => {
  const { columns } = props;

  return (
    <div className="user-info-transfer-table">
      <InfoTable>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.title}>{column.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {columns.map((column) => (
              <td className={column.active ? 'active' : ''} key={column.value}>
                {column.value}
              </td>
            ))}
          </tr>
        </tbody>
      </InfoTable>
    </div>
  );
};

export default UserInfoTransferTable;
